import { getDefaultTablePagination } from 'shared/UI/UIKit/Table';
import type { AppTableState } from 'shared/UI/UIKit/Table';

const PAGE_SIZE_OPTIONS = ['5', '10', '20', '50', '100'];

export const classGroupsInitialTableState: AppTableState = {
  sorters: [
    { key: 'educationalClassId', dataIndex: ['educationalClassId'] },
    { key: 'subjectId', dataIndex: ['subjectId'] },
    { key: 'teacherId', dataIndex: ['teacherId'] },
    { key: 'name', dataIndex: ['name'] },
  ],
  filters: [],
  pagination: {
    ...getDefaultTablePagination(),
    pageSize: 10,
    pageSizeOptions: PAGE_SIZE_OPTIONS,
  },
};
